<div #richTextViewer [class]="'rich-text-editor-container inline readOnly align-' + textAlign">
  <quill-editor [(ngModel)]="richText" [modules]="modules" [readOnly]="true" placeholder="" theme="ghQuillTheme"></quill-editor>

  <ui-mention-popover *ngIf="mentionElRef" [user]="mentionPopoverUser" [sourceMentionEl]="mentionElRef" (closed)="mentionPopoverClosed()"></ui-mention-popover>
</div>
